
import 'react-datepicker/dist/react-datepicker.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-quill/dist/quill.snow.css';
import 'emoji-mart/css/emoji-mart.css';
import './styles/main.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Bootstrap from 'services/route/bootstrap';
import 'services/global';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'services/toast';
import { LoadingContainer } from 'services/loading';
import './i18n';

// Thêm dòng này
import ScrollButtons from './components/ScrollButtons';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <BrowserRouter>
    <Bootstrap />
    <LoadingContainer />
    <ToastContainer />

    {/* Hai nút điều hướng lên/xuống */}
    <ScrollButtons />
  </BrowserRouter>
);

reportWebVitals();
